import { render, staticRenderFns } from "./AdviceBubble.vue?vue&type=template&id=52802c8a&scoped=true&"
import script from "./AdviceBubble.vue?vue&type=script&lang=js&"
export * from "./AdviceBubble.vue?vue&type=script&lang=js&"
import style0 from "./AdviceBubble.vue?vue&type=style&index=0&id=52802c8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52802c8a",
  null
  
)

export default component.exports